import { ReactElement } from "react"
import facebook from '../../assets/facebook.webp'
import instagram from '../../assets/instagram.webp'
import linkedin from '../../assets/linkedin.webp'
import logoGT7 from '../../assets/logo-gt7.webp'
import logo from '../../assets/logo-positivo.webp'
import { FooterProps } from "./footer-props"
import * as S from './footer-style'

export function FooterSimple ({ address, contact }: FooterProps): ReactElement {
  return <S.Container>
    <S.InfoContainer>
      <S.LogoContainer>
        <S.Logo src={logo} alt="Cartão de TODOS" />
      </S.LogoContainer>
      <S.ContactContainer>
        <S.ContactItemContainer>
          Redes sociais
          <S.SocialContainer>
            <S.Social href="https://br.linkedin.com/company/cartaodetodos" rel="noopener noreferrer" target="_blank">
              <img src={linkedin} alt="" />
            </S.Social>
            <S.Social href="https://www.instagram.com/cartaodetodosbrasil/" rel="noopener noreferrer" target="_blank">
              <img src={instagram} alt="" />
            </S.Social>
            <S.Social href="https://www.facebook.com/cartaodetodosbrasil/" rel="noopener noreferrer" target="_blank">
              <img src={facebook} alt="" />
            </S.Social>
          </S.SocialContainer>
        </S.ContactItemContainer>
        <S.ContactItemContainer>
          Vendas <S.Phone href="tel:08007292067">0800 729 2067</S.Phone>
        </S.ContactItemContainer>
        <S.ContactItemContainer>
          SAC <S.Phone href="tel:08002838916">0800 283 8916</S.Phone>
        </S.ContactItemContainer>
      </S.ContactContainer>
    </S.InfoContainer>
    <S.Disclaimer>
      * Cartão de desconto não é plano de saúde, não garante e não se responsabiliza pelos serviços oferecidos e pelo pagamento das despesas, nem assegura desconto em todos os serviços obrigatoriamente garantidos por plano de saúde. Tudo o que o cliente usar ou comprar será por ele pago ao prestador, assegurando-se apenas os preços e descontos que constam na relação de empresas e serviços conveniados disponibilizados no site www.cartaodetodos.com.br. O atendimento será em até 15 dias, mediante disponibilidade na clínica. Consulte a clínica parceira para as especialidades disponíveis e condições para marcar as consultas.
    </S.Disclaimer>
    <S.LogoGT7Container>
      <S.LogoGT7 src={logoGT7} alt="GT7" />
    </S.LogoGT7Container>
  </S.Container>
}